/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isAnimationControls as o}from"../../animation/utils/is-animation-controls.js";import{isVariantLabel as i}from"./is-variant-label.js";import{variantProps as n}from"./variant-props.js";function r(r){return o(r.animate)||n.some((o=>i(r[o])))}function t(o){return Boolean(r(o)||o.variants)}export{r as isControllingVariants,t as isVariantNode};
//# sourceMappingURL=is-controlling-variants.js.map
